// extracted by mini-css-extract-plugin
module.exports = {"carousel":"HomeBanner_carousel__500nM","img":"HomeBanner_img__6dlJf"};